import { render, staticRenderFns } from "./CustomerWebhook.vue?vue&type=template&id=2cd173be&"
import script from "./CustomerWebhook.vue?vue&type=script&lang=js&"
export * from "./CustomerWebhook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports